import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import './style.css';

const menus = [
    { id: 1, link: "/", key: "home" },
    { id: 2, link: "/event", key: "events" },
    { id: 3, link: "/service", key: "services" },
    { id: 4, link: "/about", key: "about" },
    { id: 5, link: "/blog", key: "blog" },
    { id: 6, link: "/contact", key: "contact" },
]


const MobileMenu = () => {

    const { t } = useTranslation("navbar");
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{t(item.key)}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <LocalizedLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</LocalizedLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <LocalizedLink className="active"
                                        to={item.link}>{t(item.key)}</LocalizedLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

                <LanguageSwitcher className="mobile-lang" />

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;